export enum CasinoSettingsTab {
  CASINOS = 'casinos',
  PARTNER_SPOTLIGHTS = 'partner-spotlights',
}
